(function(angular, module) {var ProgramColumns, PsePrepReportController, StudentColumns, psePrepReportStates, resolvePsePrepReportDataLoader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProgramColumns = [
  {
    name: 'placement',
    label: 'Placement in PSE',
    num: 'placed',
    denom: 'students',
    num_desc: 'students placed in PSE.',
    denom_desc: 'students exited.'
  }, {
    name: 'fafsa',
    label: 'Completed FAFSA',
    num: 'fafsa_yes',
    denom: 'students',
    num_desc: 'students completed FAFSA.',
    denom_desc: 'students exited.'
  }, {
    name: 'applications',
    label: 'Completed PSE Applications',
    num: 'applications_yes',
    denom: 'applications_known',
    num_desc: 'students completed PSE applicaitons.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'test',
    label: 'Took PSE Placement Tests',
    num: 'test_yes',
    denom: 'test_known',
    num_desc: 'students took PSE placement tests.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'credits',
    label: 'Earned PSE Credits',
    num: 'credits_yes',
    denom: 'credits_known',
    num_desc: 'students earned PSE credits.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'goal_entry',
    label: 'PSE Goal at Entry',
    num: 'goal_entry_yes',
    denom: 'goal_entry_known',
    num_desc: 'students desired a degree at entry',
    denom_desc: 'students with known answer.'
  }, {
    name: 'goal_exit',
    label: 'PSE Goal at Exit',
    num: 'goal_exit_yes',
    denom: 'goal_exit_known',
    num_desc: 'students desired a degree at exit.',
    denom_desc: 'students with known answer.'
  }
];

StudentColumns = [
  {
    name: 'completed_fafsa',
    num: 'fafsa_yes',
    denom: 'students',
    num_desc: 'students completed FAFSA.',
    denom_desc: 'students exited.'
  }, {
    name: 'pse_credits_count',
    num: 'credits_yes',
    denom: 'credits_known',
    num_desc: 'students earned PSE credits.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'pse_placement_test',
    num: 'test_yes',
    denom: 'test_known',
    num_desc: 'students took PSE placement tests.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'pse_applications',
    num: 'applications_yes',
    denom: 'applications_known',
    num_desc: 'students completed PSE applicaitons.',
    denom_desc: 'students with known answer.'
  }, {
    name: 'entry_desired_credential',
    num: 'goal_entry_yes',
    denom: 'goal_entry_known',
    num_desc: 'students desired a degree at entry',
    denom_desc: 'students with known answer.'
  }, {
    name: 'exit_desired_credential',
    num: 'goal_exit_yes',
    denom: 'goal_exit_known',
    num_desc: 'students desired a degree at exit.',
    denom_desc: 'students with known answer.'
  }
];

psePrepReportStates = function($stateProvider, TagUrl) {
  'ngInject';
  var programUrl, url;
  url = new TagUrl().addTagTypes(['program', 'location', 'participant']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  $stateProvider.state('reports.psePrep', {
    url: url.buildUrl('/pse-prep'),
    params: url.params,
    data: {
      tagUrl: url
    },
    reloadOnSearch: false,
    templateUrl: 'reports/psePrep/programs',
    controller: 'PsePrepReportController',
    controllerAs: '$ctrl',
    resolve: {
      program: function() {
        return null;
      },
      dataLoader: resolvePsePrepReportDataLoader,
      columns: function() {
        return ProgramColumns;
      }
    }
  });
  programUrl = new TagUrl().addTagTypes(['participant']).addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  return $stateProvider.state('program.reports.psePrep', {
    url: programUrl.buildUrl('/pse-prep'),
    params: programUrl.params,
    data: {
      tagUrl: programUrl
    },
    reloadOnSearch: false,
    templateUrl: 'reports/psePrep/students',
    controller: 'PsePrepReportController',
    controllerAs: '$ctrl',
    resolve: {
      columns: function() {
        return StudentColumns;
      },
      dataLoader: resolvePsePrepReportDataLoader
    }
  });
};

resolvePsePrepReportDataLoader = function($http, $timeout, $state, ApiUrl, program) {
  'ngInject';
  var baseUrl, timeoutPromise, url;
  timeoutPromise = null;
  baseUrl = ApiUrl.partial('reports', 'pse-prep');
  url = program ? baseUrl(program.id) : baseUrl();
  return function(tags, sort, page) {
    var getData;
    $timeout.cancel(timeoutPromise);
    getData = function() {
      var params;
      params = angular.extend({}, tags, {
        sort: sort,
        page: page
      });
      $state.go('.', params, {
        location: 'replace'
      });
      return $http.get(url, {
        params: params
      }).then(function(result) {
        return result.data;
      });
    };
    timeoutPromise = $timeout(getData, 100);
    return timeoutPromise;
  };
};

PsePrepReportController = (function() {

  /* @ngInject */
  function PsePrepReportController($scope, $stateParams, dataLoader, columns) {
    this.dataLoader = dataLoader;
    this.columns = columns;
    this.onPageChange = bind(this.onPageChange, this);
    this.loading = true;
    this.tags = void 0;
    this.sort = $stateParams.sort || 'name';
    this.page = $stateParams.page || 1;
    $scope.$watch('$ctrl.pager.page', this.onPageChange);
  }

  PsePrepReportController.prototype.reloadData = function() {
    this.loading = true;
    return this.dataLoader(this.tags, this.sort, this.page).then((function(_this) {
      return function(data) {
        _this.loading = false;
        _this.items = data.items;
        _this.totals = data.totals;
        _this.maximums = data.maximums;
        return _this.pager = data.pager;
      };
    })(this));
  };

  PsePrepReportController.prototype.tagChange = function(tags) {
    if (angular.equals(tags, this.tags)) {
      return;
    }
    if (angular.isDefined(this.tags)) {
      this.page = 1;
    }
    this.tags = tags;
    return this.reloadData();
  };

  PsePrepReportController.prototype.onPageChange = function(page) {
    if (!page || page === this.page) {
      return;
    }
    this.page = page;
    return this.reloadData();
  };

  PsePrepReportController.prototype.onSortChange = function() {
    return this.reloadData();
  };

  return PsePrepReportController;

})();

module.config(psePrepReportStates);

module.controller('PsePrepReportController', PsePrepReportController);
})(angular, angular.module("dybReports"));